import { Button, Col, Space } from 'antd';
import React from 'react';

export type TAssetEditorAction = {
  label: string,
  icon?: React.ReactNode,
  key: string
}

export type TAssetEditorActions = {
  actions: TAssetEditorAction[]
  handler: (key: string, value: any) => void,
}

const AssetEditorActions: React.FC<TAssetEditorActions> = ({ actions, handler }) => {
  return (
    <Col>
      <Space size={[10, 10]}>
        {actions.map((action) => {
          return (
            <Button
              icon={action.icon}
              key={action.key}
              onClick={() => {
                handler(action.key, null);
              }}
            >
              {action.label}
            </Button>
          )
        })}
      </Space>
    </Col>
  )
}

export default AssetEditorActions;